module.exports = __webpack_public_path__ + "static/media/icon-increase.6a4bc345.svg";